import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App.tsx';
import { ProvvederAutenticazione } from './auth/contesto.tsx';
import './stili/caratteri.css';
import './stili/globale.css';

const radice = document.getElementById('radice');
if (radice === null) throw new Error('Elemento #radice non trovato in index.html');

createRoot(radice).render(
  <StrictMode>
    <BrowserRouter>
      <ProvvederAutenticazione>
        <App />
      </ProvvederAutenticazione>
    </BrowserRouter>
  </StrictMode>,
);
